
import { RowLabelVehicleDto } from "@/dtos";
import { LabelVehicle } from "@/entities";

export const formatTableLabelVehicleDto = async (label: LabelVehicle[]): Promise<RowLabelVehicleDto[]> => {
    return label.map((x) => {
        const row: RowLabelVehicleDto = {
            ...x,
            is_active: true
        }
        return row;
    });
}